module.exports = __webpack_public_path__ + "static/img/SR.e2468314.svg";